import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { MyTenantsPageContext } from "./tenantsDashContext";

import store from "./redux/store";

import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MyTenantsPageContext>
        {" "}
        {/* Add your context provider here */}
        <App />
      </MyTenantsPageContext>
    </Provider>
  </React.StrictMode>
);
